import React from "react";

const PageHeroSection = ({
	heroTitle,
	heroIcon,
	heroIconAltText,
	subtitle,
	subtitle2,
	intro,
}) => (
	<section className="mx-auto container px-4 xl:pt-32 lg:px-28 xl:px-0 md:px-0">
		<div className="relative flex flex-col lg:md:w-full  gap-4 xl:gap-8 w-full pt-8 pb-8 md:px-28 lg:px-0 xl:px-0">
			<div className="flex flex-col lg:flex-row gap-4 items-start lg:items-center">
				{heroIcon && (
					<img
						src={heroIcon}
						alt={heroIconAltText}
						className="h-8 md:h-10"
					/>
				)}
				<h1 className="text-4xl md:text-5xl xl:text-6xl text-white font-bold">
					{heroTitle}
				</h1>
			</div>
			<h2 className="text-white xl:max-w-[50%] font-bold w-full uppercase text-sm empty:mt-0 empty:mb-0">
				{subtitle}
			</h2>
			{subtitle2 && (
				<h3 className="text-white w-full font-bold uppercase text-sm mb-[25px] empty:mb-0">
					{subtitle2}
				</h3>
			)}
			<p className="text-white w-full text-base font-normal max-w-[900px] empty:mt-0 leading-relaxed">
				{intro}
			</p>
		</div>
	</section>
);

export default PageHeroSection;
